import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';


import { SocketContext } from '../context/SocketContext'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'
import { useHideMenu } from '../hooks/useHideMenu'
import { UseCurrencyFormat } from '../hooks/useCurrencyFormat';
import { useGetPantallas } from '../hooks/useGetPantallas';

import { SelectElement } from "../components/selectElement";
import { InformeTicketHoy } from '../components/informeTicketHoy';
import { NoAcceso } from '../components/NoAcceso';
import LoadingOverlay from '../components/LoadingOverlay';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
}

     
// let usuario = getUsuarioStorage();
// const entidad = usuario.entidad;



export const Informes = () => {

    let [usuario] = useState( getUsuarioStorage() )
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

    const navigate = useNavigate();
    useEffect(() => {
      if(usuario.uidUsuario === null){
          // return <Navigate to="/ingreso" />
          navigate("/Ingreso")
      }
    }, [usuario.uidUsuario, navigate])


    useHideMenu(false);
    
    const formatoNumero = (numero) => {

        return UseCurrencyFormat(numero);
    }
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [ atencion, setAtencion ] = useState([]);
    const [ atencionTipo, setAtencionTipo ] = useState([]);
    const [modulo, setModulo] = useState([]);
    const [agente, setAgente] = useState([]);
    
    const [ listaAtencionMes, setListaAtencionMes ] = useState([]);
    const [ totalAtencion, setTotalAtencion ] = useState(0);
    const [ atencionPromedioAtencion, setAtencionPromedioAtencion ] = useState(0);
    

    const [ listaAtencionModulo, setListaAtencionModulo ] = useState([]);
    const [ totalAtencionModulo, setTotalAtencionModulo ] = useState(0);
    const [ atencionPromedioModulo, setAtencionPromedioModulo ] = useState(0);


    const [ listaAtencionAgente, setListaAtencionAgente ] = useState([]);
    const [ totalAtencionAgente, setTotalAtencionAgente ] = useState(0);
    const [ atencionPromedioAgente, setAtencionPromedioAgente ] = useState(0);
    

    const [ fechaInicio, setFechaInicio ] = useState('');
    const [ fechaFinal, setFechaFinal ] = useState('');
    const [ filtroTiempo, setFiltroTiempo ] = useState('dia');

    const [ moduloSeleccionado, setModuloSeleccionado ] = useState('');
    const [ atencionSeleccionado, setAtencionSeleccionado ] = useState('');
    const [ agenteSeleccionado, setAgenteSeleccionado ] = useState('');



   

     // tabla
   
    const datos={
        entidad,
    }

    useEffect(() => {
        async function fetchAtenciones() {
            setIsLoading(true)
            await socket.emit('select-TipoAtencion', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidTipoAtencion, label: item.tipoAtencion.toUpperCase() } ) )
                setAtencion( opciones )
            })
        }

        fetchAtenciones();
               
        return () => {
            socket.off('select-TipoAtencion')
        }
    }, [ socket ])



    useEffect(() => {
        async function fetchModulos() {
            setIsLoading(true)
            await socket.emit('select-Modulos', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidModulo, label: item.modulo.toUpperCase() } ) )
                setModulo( opciones )
            })
        }

        fetchModulos();
               
        return () => {
            socket.off('select-Modulos')
        }
    }, [ socket ])

    useEffect(() => {
        async function fetchAgentes() {
            setIsLoading(true)
            await socket.emit('select-Usuarios', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidUsuario, label: item.nombreCompleto.toUpperCase() } ) )
                setAgente( opciones )
            })
        }

        fetchAgentes();
               
        return () => {
            socket.off('select-Usuarios')
        }
    }, [ socket ])

    useEffect( () => {
        
        const fecini = document.getElementById('fechaInicio');
        if( fecini ) setFechaInicio(document.getElementById('fechaInicio').value);

        const fecfin = document.getElementById('fechaFinal');
        if( fecfin ) setFechaFinal(document.getElementById('fechaFinal').value);

        
        if( fechaInicio === "" || fechaFinal === "" ) return;

        datos.fechaInicio = fechaInicio;
        datos.fechaFinal = fechaFinal;
        datos.modulo = moduloSeleccionado;
        datos.atencion = atencionSeleccionado;
        datos.uidAgente = agenteSeleccionado;
        datos.filtroTiempo = filtroTiempo;


        async function fetchListaAtenciones() {
            setIsLoading(true)
            await socket.emit('lista-Atenciones-Mes', datos, async ( lista ) => {
               
                let keys = new Set();
                const fechas = lista.filter(obj => {
                    if (!keys.has(obj['atendido'])) {
                        keys.add(obj['atendido']);
                        return true;
                    }
                    return false;
                });

                if(atencionSeleccionado === ""){
                    await socket.emit('lista-Tipo-Atencion', datos, ( listaTipo ) =>{
                        setAtencionTipo(listaTipo);
                        
                        atencionTipo.forEach( el => {
                            
                            fechas.forEach(fec => {
                                
                                const existe = lista.some(obj => obj.atendido === fec.atendido && obj.tipoAtencion === el.tipoAtencion);
                                if (!existe) {
                                    lista.push({
                                            atendido: fec.atendido,
                                            cantidad: 0,
                                            tipoAtencion : el.tipoAtencion
                                        });
                                }
    
                            });
    
                        });
    
                        // lista.sort((a, b) => {
                        //     if (a.atendido < b.atendido) {
                        //         return -1;
                        //     }
                        //     if (a.atendido > b.atendido) {
                        //         return 1;
                        //     }
                        //     // Si los nombres son iguales, ordenar por 'edad'
                        //     if (a.atendido === b.atendido) {
                        //         return a.tipoAtencion - b.tipoAtencion;
                        //     }
                        //     return 0;
                        // });
    
                        console.log(lista);
                        
                        setListaAtencionMes( 
                            lista.sort((a, b) => {
                                if (a.atendido < b.atendido) {
                                    return -1;
                                }
                                if (a.atendido > b.atendido) {
                                    return 1;
                                }
                                // Si los nombres son iguales, ordenar por 'edad'
                                if (a.atendido === b.atendido) {
                                    // return a.tipoAtencion < b.tipoAtencion;
                                    if (a.tipoAtencion < b.tipoAtencion) {
                                        return -1;
                                    }
                                    if (a.tipoAtencion > b.tipoAtencion) {
                                        return 1;
                                    }
                                }
                                return 0;
                            }) 
                        )
                        
                    })

                }else{

                    setListaAtencionMes( 
                        lista.sort((a, b) => {
                            if (a.atendido < b.atendido) {
                                return -1;
                            }
                            if (a.atendido > b.atendido) {
                                return 1;
                            }
                            // Si los nombres son iguales, ordenar por 'edad'
                            if (a.atendido === b.atendido) {
                                // return a.tipoAtencion < b.tipoAtencion;
                                if (a.tipoAtencion < b.tipoAtencion) {
                                    return -1;
                                }
                                if (a.tipoAtencion > b.tipoAtencion) {
                                    return 1;
                                }
                            }
                            return 0;
                        }) 
                    )
                }
                
                
               setIsLoading(false)
               const total = lista.map(item => item.cantidad).reduce( (prev, curr) => prev + curr, 0);
               setTotalAtencion(total);
            })

            setIsLoading(true)
            await socket.emit('atenciones-Promedio-Atencion', datos, ( lista ) => {
                setIsLoading(false)
                setAtencionPromedioAtencion( lista[0] )
            })
    

        }

        async function fetchListaAtencionesModulo() {
            setIsLoading(true)
            await socket.emit('lista-Atenciones-Modulo', datos, ( lista ) => {
                setIsLoading(false)
               setListaAtencionModulo( lista )
               const total = lista.map(item => item.cantidad).reduce( (prev, curr) => prev + curr, 0);
               setTotalAtencionModulo(total);
            })

            setIsLoading(true)
            await socket.emit('atenciones-Promedio-Modulo', datos, ( lista ) => {
                setIsLoading(false)
                setAtencionPromedioModulo( lista[0] )
                
            })

            
            await socket.emit('atenciones-Promedio-Modulo-separado', datos, ( lista ) => {
                console.log(lista);
                
            })

        }

        async function fetchListaAtencionesAgente() {
            setIsLoading(true)
            await socket.emit('lista-Atenciones-Agente', datos, ( lista ) => {
                setIsLoading(false)
               setListaAtencionAgente( lista )
               const total = lista.map(item => item.cantidad).reduce( (prev, curr) => prev + curr, 0);
               setTotalAtencionAgente(total);
            })

            setIsLoading(true)
            await socket.emit('atenciones-Promedio-Agente', datos, ( lista ) => {
                setIsLoading(false)
                setAtencionPromedioAgente( lista[0] )
            })


        }

        fetchListaAtenciones();
        fetchListaAtencionesModulo();
        fetchListaAtencionesAgente();

        return () => {
            socket.off('lista-Atenciones-Mes');
            socket.off('lista-Atenciones-Modulo');
        }
        
    }, [ socket, atencionSeleccionado, moduloSeleccionado, fechaInicio, fechaFinal, agenteSeleccionado, filtroTiempo ])

    // useEffect( () => {
    //     // console.log(moduloSeleccionado)
    //     // console.log(atencionSeleccionado)

    //     // console.log(fechaInicio)
    //     // console.log(fechaFinal)

    //     if( fechaInicio ==="" || fechaFinal === "" ) return;

    //     datos.fechaInicio = fechaInicio;
    //     datos.fechaFinal = fechaFinal;
    //     datos.modulo = moduloSeleccionado;
    //     datos.atencion = atencionSeleccionado;
    //     datos.uidAgente = agenteSeleccionado;
    //     datos.filtroTiempo = filtroTiempo;

    //     async function fetchListaAtenciones() {
    //         await socket.emit('lista-Atenciones-Mes', datos, ( lista ) => {
    //            setListaAtencionMes( lista )
    //            const total = lista.map(item => item.cantidad).reduce( (prev, curr) => prev + curr, 0);
    //            setTotalAtencion(total);
    //         })

    //     }

    //     async function fetchListaAtencionesModulo() {
    //         await socket.emit('lista-Atenciones-Modulo', datos, ( lista ) => {
    //            setListaAtencionModulo( lista )
    //            const total = lista.map(item => item.cantidad).reduce( (prev, curr) => prev + curr, 0);
    //            setTotalAtencionModulo(total);
    //         })

    //     }

    //     async function fetchListaAtencionesAgente() {
    //         await socket.emit('lista-Atenciones-Agente', datos, ( lista ) => {
    //            setListaAtencionAgente( lista )
    //            const total = lista.map(item => item.cantidad).reduce( (prev, curr) => prev + curr, 0);
    //            setTotalAtencionAgente(total);
    //         })

    //     }

        
    //     fetchListaAtenciones();
    //     fetchListaAtencionesModulo();
    //     fetchListaAtencionesAgente();

       
        
    // }, [ socket, fechaInicio, fechaFinal, atencionSeleccionado, moduloSeleccionado, agenteSeleccionado, filtroTiempo ])

    


    const handleFechaChange = ( ev ) =>{
        console.log(ev.target.value)
        const fechaFinal = document.getElementById('fechaFinal');
        setFechaInicio(ev.target.value)
        setFechaFinal(ev.target.value)
        fechaFinal.setAttribute("min", ev.target.value);
        fechaFinal.value= ev.target.value;

    }

    const exportToExcel = ( tabla, name) => {
        // const data = lista;
        // // const headers = ['fecha', 'Módulo', 'Cantidad'];
        
        // // return console.log(data)
        
        // const sheetName= "Atenciones x módulo" ;
        // const worksheet = XLSX.utils.json_to_sheet(data);
        // const workbook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        // const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        // const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // const url = URL.createObjectURL(dataBlob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', 'exported_data.xlsx');
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

            const table = document.getElementById(`${tabla}`);
            const wb = XLSX.utils.table_to_book(table, {
                dateNF: 'YYYY-MM-DD',
              });

              for (const col in wb) {
                if (wb.hasOwnProperty(col) && col[0] !== '!') {
                  const cell = wb[col];
                  if (cell.t === 'd') {
                    cell.z = 'yyyy-mm-dd';
                  }
                }
              }

            /* Export to file (start a download) */
            XLSX.writeFile(wb, `${name}.xlsx`);

    };

    const exportToExcelFromData = ( data, name) => {
      
        console.log(data);
        const ws = XLSX.utils.json_to_sheet(data, {
            dateNF: 'yyyy-mm-dd' // Set the date format
          });
        
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
          XLSX.writeFile(wb, `${name}.xlsx`);
      
    };


    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }
    else if( !pantallas.includes("informes") ) {
        return( <NoAcceso /> )
    } 
    else {

        {isLoading && <LoadingOverlay />}
        return (
            <div className={` ${isLoading ? 'opacity' : ''} m-5`} 
                style={{minHeight:'100vh'}} >
                <div className='row p-3'>
        
                    <InformeTicketHoy />
        
                    <div className="card rounded shadow p-3 mt-3 mb-3">
                            <h5 className='card-title'> <b>FILTROS</b> </h5>
                            <div className='row'>
                                <div className='row'>
                                    
                                    <div className='col-4'>
                                        <input  type="radio" 
                                                className="btn-check" 
                                                name="opcionTiempo" 
                                                id="opcionAnio" 
                                                autoComplete="off"
                                                onClick={ () => setFiltroTiempo('anio') } />
                                        <label className="btn btn-outline-primary" htmlFor="opcionAnio">Año</label>
        
                                        {' '}
                                        <input  type="radio" 
                                                className="btn-check" 
                                                name="opcionTiempo" 
                                                id="opcionMes" 
                                                autoComplete="off"
                                                onClick={ () => setFiltroTiempo('mes') } />
                                        <label className="btn btn-outline-primary" htmlFor="opcionMes">Mes</label>
        
                                        {' '}
                                        <input  type="radio" 
                                                className="btn-check" 
                                                name="opcionTiempo" 
                                                id="opcionDia" 
                                                autoComplete="off"
                                                onClick={ () => setFiltroTiempo('dia') } />
                                        <label className="btn btn-outline-primary" htmlFor="opcionDia">Día</label>
        
                                    </div>
        
                                </div>
        
        
                                <div className='form-group col-lg-3 col-12 mt-3' >
                                    <div className='label'>Inicio </div>
                                    <input 
                                        type="date" 
                                        className='form-control' 
                                        name="fechaInicio" 
                                        id="fechaInicio" 
                                        defaultValue= { formatDate(new Date()) }
                                        onChange={ ( ev ) => handleFechaChange( ev )  }
                                        placeholder="Inicio" />
                                </div>
                                
                                <div className="form-group col-lg-3 col-12 mt-3">
                                        <div className='label' > Final </div>
                                        <input
                                            type="date" 
                                            className='form-control' 
                                            name="fechaFinal" 
                                            id="fechaFinal" 
                                            defaultValue= { formatDate(new Date()) }
                                            onChange={ (ev) => setFechaFinal(ev.target.value) }
                                            placeholder="Final" 
                                        />
                                    
                                </div>
                                
                                <div className='form-group col-lg-3 col-12 mt-3'>
                                    
                                    <div className='label'>Tipos Atención</div>
                                    <SelectElement
                                        options= { atencion }
                                        name={"uidTipoAtencion"}
                                        isMulti= {false}
                                        closeOnMenuSelect= {true}
                                        onChange= {(ev) => setAtencionSeleccionado( ev === null ? '' : ev.value ) }
                                        classname= "form-control form-control-lg" 
                                        isClearable = {true}
                                    />
                                </div>
        
                                <div className='form-group col-lg-3 col-12 mt-3'>
                                    
                                    <div className='label'>Módulos</div>
                                    <SelectElement
                                        options= { modulo }
                                        name={"uidModulo"}
                                        isMulti= {false}
                                        closeOnMenuSelect= {true}
                                        onChange= {(ev) => setModuloSeleccionado( ev === null ? '' : ev.value ) }
                                        classname= "form-control form-control-lg" 
                                        isClearable = {true}
                                    />
                                </div>
        
                                <div className='form-group col-lg-3 col-12 mt-3'>
                                    
                                    <div className='label'>Agentes</div>
                                    <SelectElement
                                        options= { agente }
                                        name={"uidUsuario"}
                                        isMulti= {false}
                                        closeOnMenuSelect= {true}
                                        onChange= {(ev) => setAgenteSeleccionado( ev === null ? '' : ev.value ) }
                                        classname= "form-control form-control-lg" 
                                        isClearable = {true}
                                    />
                                </div>
        
                            </div>
        
        
                    </div>
        
                    <div className=' form-group col-xxl-4 col-md-6 col-12 p-2'>
                        <div className='card shadow' >
                            <div className='card-header text-bg-primary'>
                                <h3 className="card-title" style={{ float: 'left', fontSize: '1.1rem', fontWeight: '400', margin: '0' }}>Tipos de Atención</h3>
                                <div className='card-tools' style={{ float: 'right', marginRight: '-.625rem'  }}>
                                    <button className= 'btn btn-sm btn-primary' onClick={() => exportToExcelFromData( listaAtencionMes, "Tipos Atencion") }><i className="fa-solid fa-file-excel"></i></button>
                                    {/* <button className= 'btn btn-sm btn-primary' onClick={() => exportToExcel( "atencionTipo", "Tipos Atencion") }><i className="fa-solid fa-file-excel"></i></button> */}
                                    
                                    
        
                                </div>
                            </div>
                            
                            <div className='card-body' id='atencionTipo'>
                                {   totalAtencion !== 0 
                                    ?   <div className='form-group'>
                                            <h5 className='card-title'>TOTAL: {totalAtencion} </h5>
                                        </div>
                                    : ""
                                }
        
                                <table width= "100%" className='table table-responsive table-striped   max400' style={{ fontSize: ".7rem" }}>
        
                                    <thead width= "100%">
                                        <tr>
                                            <th width={"10%"}>fecha</th>
                                            <th width={"40%"}>Servicio</th>
                                            <th width={"10%"}>Cant</th>
                                            <th width={"20%"}>prom. Llama</th>
                                            <th width={"20%"}>prom. Atenc</th>
                                        </tr>
                                    </thead>
        
                                    <tbody width= "100%">
                                        {listaAtencionMes.map((item, i) => (
                                            <tr key={ i }>
                                                <td width={"10%"}>{ item.atendido }</td>
                                                <td width={"40%"}>{ item.tipoAtencion.toUpperCase() }</td>
                                                <td width={"10%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.cantidad }</td>
                                                <td width={"20%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.promedioLLamado }</td>
                                                <td width={"20%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.promedioAtencion }</td>
                                            </tr>
        
                                        ))}
                                    </tbody>
                                    
                                    <tfoot width= "100%">
                                        <tr>
                                            <td width={"80%"} colSpan={ 4 } style={{ textAlign: 'end' }}>Total:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ formatoNumero(totalAtencion) }</td>
                                        </tr>
        
                                        <tr>
                                            <td width={"80%"} colSpan={ 4 } style={{ textAlign: 'end' }}>Tiempo Promedio en Llamado:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ atencionPromedioAtencion.promedioLLamado }</td>
                                        </tr>
        
                                        <tr>
                                            <td width={"80%"} colSpan={ 4 } style={{ textAlign: 'end' }}>Tiempo Promedio en Atención:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ atencionPromedioAtencion.promedioAtencion }</td>
                                        </tr>
        
                                        
                                    </tfoot>
        
                                </table>
                            </div>
        
                            {/* <div className='card-footer'>
                                footer
                            </div> */}
        
                            
                        </div>
                    </div>
        
                    {/* Atenciones por módulo */}
                    <div className=' form-group col-xxl-4 col-md-6 col-12 p-2'>
                        <div className='card shadow' >
                            <div className='card-header text-bg-success'>
                                <h3 className="card-title" style={{ float: 'left', fontSize: '1.1rem', fontWeight: '400', margin: '0' }} >Atenciones x Módulo </h3>
                                <div className='card-tools' style={{ float: 'right', marginRight: '-.625rem'  }}>
                                    <button className= 'btn btn-sm btn-success' onClick={() => exportToExcelFromData( listaAtencionModulo, "Atencion por Modulo") }><i className="fa-solid fa-file-excel"></i></button>
                                    {/* <button className= 'btn btn-sm btn-success' onClick={() => exportToExcel( "atencionModulo", "Atencion por Modulo") }><i className="fa-solid fa-file-excel"></i></button> */}
        
                                    
        
                                </div>
                            </div>
                            
                            <div className=' card-body' id='atencionModulo'>
                                {   totalAtencionModulo !== 0 
                                    ?   <div className='form-group'>
                                            <h5 className='card-title'>TOTAL: {totalAtencionModulo} </h5>
                                        </div>
                                    : ""
                                }
                                <table width= "100%"  className='table table-responsive table-striped max400' style={{ fontSize: ".7rem" }}>
        
                                    <thead>
                                        <tr>
                                            <th width={"10%"}>fecha</th>
                                            <th width={"40%"}>Módulo</th>
                                            <th width={"10%"}>Cant</th>
                                            <th width={"20%"}>prom. Llama</th>
                                            <th width={"20%"}>prom. Atenc</th>
                                        </tr>
                                    </thead>
        
                                    <tbody>
                                    {listaAtencionModulo.map((item, i) => (
                                        <tr key={ i }>
                                            <td width={"10%"}>{ item.atendido }</td>
                                            <td width={"40%"}>{ item.modulo.toUpperCase() }</td>
                                            <td width={"10%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.cantidad }</td>
                                            <td width={"20%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.promedioLLamado }</td>
                                            <td width={"20%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.promedioAtencion }</td>
                                        </tr>
        
                                    ))}
                                    </tbody>
        
                                    <tfoot width= "100%">
                                        <tr>
                                            <td width={"80%"} colSpan={ 4 } style={{ textAlign: 'end' }}>Total:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ formatoNumero(totalAtencionModulo) }</td>
                                        </tr>
        
                                        <tr>
                                            <td width={"80%"} colSpan={ 4 } style={{ textAlign: 'end' }}>Tiempo Promedio en Llamado:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ atencionPromedioModulo.promedioLLamado }</td>
                                        </tr>
        
                                        <tr>
                                            <td width={"80%"} colSpan={ 4 } style={{ textAlign: 'end' }}>Tiempo Promedio en Atención:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ atencionPromedioModulo.promedioAtencion }</td>
                                        </tr>
        
                                        
                                    </tfoot>
        
                                </table>
                            </div>
                            
                        </div>
                    </div>
        
                    {/* Atenciones por Agente */}
                    <div className=' form-group col-xxl-4 col-md-6 col-12 p-2'>
                        <div className='card shadow' >
                            <div className='card-header text-bg-warning'>
                                <h3 className="card-title" style={{ float: 'left', fontSize: '1.1rem', fontWeight: '400', margin: '0' }}>Atenciones x Agente </h3>
                                <div className='card-tools' style={{ float: 'right', marginRight: '-.625rem'  }}>
                                    <button className= 'btn btn-sm btn-warning' onClick={() => exportToExcelFromData( listaAtencionAgente, "Atencion Agente") }><i className="fa-solid fa-file-excel"></i></button>
        
                                    
        
                                </div>
                            </div>
                            
                            <div className='card-body' id='atencionAgente'>
                                {   totalAtencionAgente !== 0 
                                    ?   <div className='form-group'>
                                            <h5 className='card-title'>TOTAL: {totalAtencionAgente} </h5>
                                        </div>
                                    : ""
                                }
                                <table width= "100%" className='table table-responsive table-striped   max400' style={{ fontSize: ".7rem" }}>
        
                                    <thead>
                                        <tr>
                                            <th width={"10%"}>fecha</th>
                                            <th width={"40%"}>Agente</th>
                                            <th width={"10%"}>Cant</th>
                                            <th width={"20%"}>prom. Llama</th>
                                            <th width={"20%"}>prom. Atenc</th>
                                        </tr>
                                    </thead>
        
                                    <tbody>
                                    {listaAtencionAgente.map((item, i) => (
                                        <tr key={ i }>
                                            <td width={"10%"}>{ item.atendido }</td>
                                            <td width={"40%"}>{ item.nombreCompleto.toUpperCase() }</td>
                                            <td width={"10%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.cantidad }</td>
                                            <td width={"20%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.promedioLLamado }</td>
                                            <td width={"20%"} style={{textAlign:'end', paddingRight: '1rem'}}>{ item.promedioAtencion }</td>
                                        </tr>
        
                                    ))}
                                    </tbody>
        
                                    <tfoot width= "100%">
                                        <tr>
                                            <td width={"80%"} colSpan={ 2 } style={{ textAlign: 'end' }}>Total:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ formatoNumero(totalAtencionAgente) }</td>
                                        </tr>
        
                                        <tr>
                                            <td width={"80%"} colSpan={ 2 } style={{ textAlign: 'end' }}>Tiempo Promedio en Llamado:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ atencionPromedioAgente.promedioLLamado }</td>
                                        </tr>
        
                                        <tr>
                                            <td width={"80%"} colSpan={ 2 } style={{ textAlign: 'end' }}>Tiempo Promedio en Atención:</td>
                                            <td width={"20%"} style={{ textAlign: 'end', paddingRight: '1rem' }}>{ atencionPromedioAgente.promedioAtencion }</td>
                                        </tr>
        
                                        
                                    </tfoot>
        
                                </table>
                            </div>
        
                            
                        </div>
                    </div>
        
                
        
                </div>

            </div>
    
        )
    }   
         
}
